export default "__VITE_ASSET__CBXNpkQ1__"